export type SupportedSplTokens = "dust" | "str" | "samo" |"shdw";

export type CheckoutItem = {
  name: string;
  price: number;
  image: string;
  quantity: number;
  size?: string;
};

export type CheckoutConfig = {
  collect_shipping_address: boolean;
};
